import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import { createCliente } from "../api/clientes";
import { createUsuariosForm, enviarCodigoCorreo, verificarCodigo } from "../api/usuarios";
import { createFormSucursales } from "../api/sucursales";
import { createPermisosForm } from "../api/permisos";
import { facturasClienteAgregar } from "../api/facturar";
import { listDepartamento012, listMunicipio013, listTipoEstablecimiento009, listTipoDocumento002 } from "../api/hacienda";


const Registro = () => {
  const navigate = useNavigate();

  const [departamentos, setDepartamentos] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [establecimiento, setEstablecimientos] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const dep = await listDepartamento012({});
      setDepartamentos(dep.data);

      const mun = await listMunicipio013({});
      setMunicipios(mun.data);

      const est = await listTipoEstablecimiento009({});
      setEstablecimientos(est.data);

      const dtes = await listTipoDocumento002();
      setTiposDocumentoAvailable(dtes.data);

    };
    fetchData();
  }, []);

  // Estados separados
  const [usuario, setUsuario] = useState({
    id_cliente: "",
    username: "",
    codigo: "0001",
    nombre: "",
    dui: "",
    nit: "",
    apellido: "",
    correo: "",
    telefono: "",
    password: "",
  });

  const [negocio, setNegocio] = useState({
    name: "",
    nit: "",
    phone: "",
    company: "",
    email: "",
  });

  const [sucursal, setSucursal] = useState({
    id_cliente: "",
    nombre: "",
    codigo_sucursal: "",
    id_typeSucursalFacts: "",
    id_departamento: "",
    id_municipio: "",
    telefono: "",
    correo: "",
    direccion: "",
  });

  const [tiposDocumentoAvailable, setTiposDocumentoAvailable] = useState([]);
  const [idTypeFactsSelected, setIdTypeFactsSelected] = useState([]);

  const [step, setStep] = useState(1); // 1: usuario, 2: negocio, 3: sucursal, 4: facturacion
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false); // Nuevo Modal de Error
  const [showOTPModal, setShowOTPModal] = useState(false); // Modal de Verificación OTP
  const [otpCode, setOtpCode] = useState(""); // Código ingresado por el usuario

  const handleSucursalChange = (e) => {
    setSucursal({
      ...sucursal,
      [e.target.name]: e.target.value,
    });
  };


  // Handlers separados
  const handleUsuarioChange = (e) => {
    setUsuario({
      ...usuario,
      [e.target.name]: e.target.value,
    });
  };

  const handleNegocioChange = (e) => {
    setNegocio({
      ...negocio,
      [e.target.name]: e.target.value,
    });
  };

  // Validación y avance de pasos
  const handleUsuarioNext = (e) => {
    e.preventDefault();
    setError("");
    // Validar campos usuario
    if (!usuario.nombre || !usuario.apellido || !usuario.username || !usuario.correo || !usuario.password || !usuario.confirmPassword) {
      return setError("Por favor completa: Nombre, Apellido, Usuario/Login, Correo electrónico y Contraseña.");
    }
    if (usuario.password !== usuario.confirmPassword) {
      return setError("Las contraseñas no coinciden.");
    }
    setNegocio(prev => ({ ...prev, email: usuario.correo }));
    setSucursal(prev => ({ ...prev, correo: usuario.correo }));
    setStep(2);
  };

  const handleNegocioNext = (e) => {
    e.preventDefault();
    setError("");
    // Validar campos negocio
    if (!negocio.name || !negocio.nit || !negocio.phone || !negocio.company) {
      return setError("Por favor completa: Nombre del Apoderado, Nombre del negocio, NIT y Teléfono.");
    }
    setSucursal(prev => ({ ...prev, telefono: negocio.phone }));
    setStep(3);
  };

  // Opciones de departamentos
  const opcionesDepartamentos = departamentos.map((d) => ({
    value: d.id,
    label: `${d.codigo} | ${d.name}`,
  }));

  // Opciones de municipios filtrados según departamento
  const opcionesMunicipios = municipios
    .filter((m) => Number(m.id_departamentoFact) === Number(sucursal.id_departamento))
    .map((m) => ({
      value: m.id,
      label: `${m.codigo} | ${m.name}`,
    }));

  // Handler cuando se selecciona un departamento
  const handleDepartamentoChange = (selectedOption) => {
    setSucursal({
      ...sucursal,
      id_departamento: selectedOption ? selectedOption.value : "",
      id_municipio: "", // limpiar municipio al cambiar de departamento
    });
  };

  // Handler cuando se selecciona un municipio
  const handleMunicipioSelect = (selectedOption) => {
    setSucursal({
      ...sucursal,
      id_municipio: selectedOption ? selectedOption.value : "",
    });
  };


  // Valor seleccionado de municipio
  const selectedMun = opcionesMunicipios.find(
    (opt) => opt.value === Number(sucursal.id_municipio)
  );


  const opcionesEstablecimiento = establecimiento.map((es) => ({
    value: es.id,
    label: `${es.codigo} | ${es.name}`,
  }));


  const toggleTypeFactSelection = (id) => {
    setIdTypeFactsSelected((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };


  const handleSucursalNext = (e) => {
    e.preventDefault();
    setError("");
    // Validar campos sucursal
    if (!sucursal.nombre || !sucursal.id_typeSucursalFacts || !sucursal.id_departamento || !sucursal.id_municipio || !sucursal.telefono || !sucursal.direccion) {
      return setError("Por favor completa: Nombre de la sucursal, Establecimiento, Departamento, Municipio, Teléfono y Dirección.");
    }
    setStep(4);
  };

  const handleFinalSubmit = async () => {
    setError("");
    setSuccess("");
    setIsSubmitting(true);

    try {
      // 1. Enviar el código de verificación al correo del usuario
      const sendCodeResponse = await enviarCodigoCorreo({ correo: usuario.correo });

      if (sendCodeResponse?.status === 1 || sendCodeResponse?.estado === 1) {
        // Ocultar resumen, mostrar OTP
        setShowSummaryModal(false);
        setShowOTPModal(true);
        setIsSubmitting(false);
      } else {
        // Manejar error desde el backend (ej: correo ya registrado u otro)
        setError(sendCodeResponse?.msg || "No se pudo enviar el código de verificación.");
        setShowErrorModal(true);
        setIsSubmitting(false);
      }
    } catch (err) {
      console.error(err);
      const errorMsg = err.response?.data?.msg || err.response?.data?.message || err.response?.data?.error || err.message || "Ocurrió un problema, intenta más tarde.";
      setError(errorMsg);
      setShowErrorModal(true);
      setIsSubmitting(false);
    }
  };

  const handleVerifyAndRegister = async () => {
    if (!otpCode) {
      setError("Por favor, ingresa el código de verificación.");
      return;
    }

    setError("");
    setIsSubmitting(true);

    try {
      // 2. Verificar el código
      const verifyResponse = await verificarCodigo({ correo: usuario.correo, codigo: otpCode });

      if (verifyResponse?.status === 1 || verifyResponse?.estado === 1) {

        // 3. Crear toda la info si es válido
        const clienteResponse = await createCliente(negocio);
        const clientId = clienteResponse.data?.id || clienteResponse.id; // Manejo seguro de la respuesta

        usuario.id_cliente = clientId;
        const usuarioResponse = await createUsuariosForm(usuario);

        sucursal.id_cliente = clientId;
        const sucursalResponse = await createFormSucursales(sucursal);

        await createPermisosForm({ id_usuario: usuarioResponse.data?.id || usuarioResponse.id, id_sucursal: sucursalResponse.data?.id || sucursalResponse.id });

        await facturasClienteAgregar({ clientId: clientId, idTypeFacts: idTypeFactsSelected });

        setSuccess("Registro completado exitosamente y tipos de factura configurados. Redirigiendo...");
        setShowOTPModal(false); // Cerrar modal OTP
        setTimeout(() => {
          navigate("/");
        }, 3000);

      } else {
        setIsSubmitting(false);
        setError(verifyResponse?.msg || "Código no válido.");
      }

    } catch (err) {
      console.error(err);
      const errorMsg = err.response?.data?.msg || err.response?.data?.message || err.response?.data?.error || err.message || "Ocurrió un problema, intenta más tarde.";
      setError(errorMsg);
      setShowErrorModal(true);
      setIsSubmitting(false);
    }
  };

  const handleShowSummary = (e) => {
    e.preventDefault();
    setError("");
    if (idTypeFactsSelected.length === 0) {
      return setError("Por favor, selecciona al menos un tipo de factura.");
    }
    setShowSummaryModal(true);
  };


  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-100 via-white to-blue-200">
      <div className="bg-white/90 backdrop-blur-md p-10 rounded-3xl shadow-2xl w-full max-w-2xl border border-blue-100 animate-fade-in">
        <h2 className="text-3xl font-bold text-center text-blue-700 mb-2 tracking-tight">Registro nuevo negocio</h2>
        <p className="text-center text-gray-500 mb-6">Completa los datos para registrar tu cuenta y tu negocio</p>
        {error && <p className="text-red-500 text-sm mb-2 text-center">{error}</p>}
        {success && <p className="text-green-500 text-sm mb-2 text-center">{success}</p>}

        <form className="space-y-8">
          {/* Paso 1: Usuario */}
          {step === 1 && (
            <div className="bg-blue-50 rounded-2xl p-6 shadow-inner border border-blue-100">
              <h3 className="text-lg font-semibold text-blue-700 mb-4">Datos del usuario</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-gray-700 text-sm font-medium">Nombre</label>
                  <input
                    type="text"
                    name="nombre"
                    value={usuario.nombre}
                    onChange={handleUsuarioChange}
                    className="mt-1 block w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-200 focus:border-blue-500 bg-gray-50"
                    autoComplete="given-name"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-medium">Apellido</label>
                  <input
                    type="text"
                    name="apellido"
                    value={usuario.apellido}
                    onChange={handleUsuarioChange}
                    className="mt-1 block w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-200 focus:border-blue-500 bg-gray-50"
                    autoComplete="family-name"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-medium">Usuario/Login </label>
                  <input
                    type="text"
                    name="username"
                    value={usuario.username}
                    onChange={handleUsuarioChange}
                    className="mt-1 block w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-200 focus:border-blue-500 bg-gray-50"
                    autoComplete="username"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-medium">Correo electrónico</label>
                  <input
                    type="email"
                    name="correo"
                    value={usuario.correo}
                    onChange={handleUsuarioChange}
                    className="mt-1 block w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-200 focus:border-blue-500 bg-gray-50"
                    autoComplete="email"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-medium">DUI</label>
                  <input
                    type="text"
                    name="dui"
                    value={usuario.dui}
                    onChange={handleUsuarioChange}
                    className="mt-1 block w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-200 focus:border-blue-500 bg-gray-50"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-medium">NIT</label>
                  <input
                    type="text"
                    name="nit"
                    value={usuario.nit}
                    onChange={handleUsuarioChange}
                    className="mt-1 block w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-200 focus:border-blue-500 bg-gray-50"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-medium">Teléfono(whatsapp para notificar)</label>
                  <input
                    type="text"
                    name="telefono"
                    value={usuario.telefono}
                    onChange={handleUsuarioChange}
                    className="mt-1 block w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-200 focus:border-blue-500 bg-gray-50"
                    autoComplete="tel"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-medium">Contraseña</label>
                  <input
                    type="password"
                    name="password"
                    value={usuario.password}
                    onChange={handleUsuarioChange}
                    className="mt-1 block w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-200 focus:border-blue-500 bg-gray-50"
                    autoComplete="new-password"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-medium">Confirmar contraseña</label>
                  <input
                    type="password"
                    name="confirmPassword"
                    value={usuario.confirmPassword || ""}
                    onChange={handleUsuarioChange}
                    className="mt-1 block w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-200 focus:border-blue-500 bg-gray-50"
                    autoComplete="new-password"
                  />
                </div>
              </div>
              <div className="flex flex-col gap-3 mt-6">
                <button
                  onClick={handleUsuarioNext}
                  className="w-full bg-blue-600 text-white py-3 rounded-xl font-semibold shadow-md hover:bg-blue-700 transition-all duration-200"
                >
                  Siguiente
                </button>
                <button
                  onClick={(e) => { e.preventDefault(); navigate("/"); }}
                  className="w-full py-3 rounded-xl font-medium text-gray-500 hover:text-gray-700 transition-colors"
                >
                  Volver al Inicio
                </button>
              </div>
            </div>
          )}

          {step === 2 && (
            <div className="bg-green-50 rounded-2xl p-6 shadow-inner border border-green-100">
              <h3 className="text-lg font-semibold text-green-700 mb-4">Datos básicos del negocio</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-gray-700 text-sm font-medium">Nombre del Apoderado</label>
                  <input type="text" name="name" value={negocio.name} onChange={handleNegocioChange} className="mt-1 block w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-200 focus:border-green-500 bg-gray-50" />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-medium">Nombre del negocio</label>
                  <input type="text" name="company" value={negocio.company} onChange={handleNegocioChange} className="mt-1 block w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-200 focus:border-green-500 bg-gray-50" />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-medium">NIT</label>
                  <input type="text" name="nit" value={negocio.nit} onChange={handleNegocioChange} className="mt-1 block w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-200 focus:border-green-500 bg-gray-50" />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-medium">Teléfono del negocio</label>
                  <input type="text" name="phone" value={negocio.phone} onChange={handleNegocioChange} className="mt-1 block w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-200 focus:border-green-500 bg-gray-50" />
                </div>
              </div>
              <div className="flex flex-col gap-3 mt-6">
                <button onClick={handleNegocioNext} className="w-full bg-green-600 text-white py-3 rounded-xl font-semibold shadow-md hover:bg-green-700 transition-all duration-200">Siguiente</button>
                <button
                  onClick={(e) => { e.preventDefault(); setStep(1); }}
                  className="w-full py-3 rounded-xl font-medium text-gray-500 hover:text-gray-700 transition-colors"
                >
                  Volver al Paso Anterior
                </button>
              </div>
            </div>
          )}

          {/* Paso 3: Sucursal */}
          {step === 3 && (
            <div className="bg-yellow-50 rounded-2xl p-6 shadow-inner border border-yellow-100">
              <h3 className="text-lg font-semibold text-yellow-700 mb-4">Datos de la sucursal principal</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-gray-700 text-sm font-medium">Código de sucursal (Generado)</label>
                  <input
                    type="text"
                    name="codigo_sucursal"
                    value={sucursal.codigo_sucursal}
                    readOnly
                    className="mt-1 block w-full px-4 py-3 border border-gray-200 bg-gray-100 rounded-xl text-gray-500 cursor-not-allowed"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 text-sm font-medium">Nombre de la sucursal</label>
                  <input
                    type="text"
                    name="nombre"
                    placeholder="Ej: Sucursal San Salvador"
                    value={sucursal.nombre}
                    onChange={handleSucursalChange}
                    className="mt-1 block w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-yellow-200 focus:border-yellow-500 bg-gray-50"
                  />
                </div>

                <div>
                  <label className="block mb-1 font-medium text-gray-700 text-sm">Establecimiento</label>
                  <ReactSelect
                    options={opcionesEstablecimiento}
                    value={
                      opcionesEstablecimiento.find(
                        (opt) => opt.value === Number(sucursal.id_typeSucursalFacts)
                      ) || null
                    }
                    onChange={(selectedOption) => {
                      let automaticCode = sucursal.codigo_sucursal;
                      if (selectedOption) {
                        const label = selectedOption.label.toLowerCase();
                        if (label.includes("casa matriz")) automaticCode = "M001P001";
                        else if (label.includes("sucursal")) automaticCode = "S001P001";
                        else if (label.includes("patio")) automaticCode = "S001P001";
                        else if (label.includes("bodega")) automaticCode = "B001P001";
                      }
                      setSucursal({
                        ...sucursal,
                        id_typeSucursalFacts: selectedOption ? selectedOption.value : "",
                        codigo_sucursal: automaticCode
                      });
                    }}
                    isClearable
                    isSearchable
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </div>

                <div>
                  <label className="block mb-1 font-medium">Departamento</label>
                  <ReactSelect
                    options={opcionesDepartamentos}
                    value={
                      opcionesDepartamentos.find(
                        (opt) => opt.value === Number(sucursal.id_departamento)
                      ) || null
                    }
                    onChange={handleDepartamentoChange}
                    isClearable
                    isSearchable
                  />
                </div>
                <div>

                  <label className="block mb-1 font-medium">Municipio</label>
                  <ReactSelect
                    options={opcionesMunicipios}
                    value={selectedMun || null}
                    onChange={handleMunicipioSelect}
                    isClearable
                    isSearchable
                    placeholder={
                      opcionesMunicipios.length
                        ? "Selecciona un municipio"
                        : "Sin municipios disponibles"
                    }
                  />
                </div>

                <div>
                  <label className="block text-gray-700 text-sm font-medium">Teléfono sucursal (vinculado al negocio)</label>
                  <input
                    type="text"
                    name="telefono"
                    value={sucursal.telefono}
                    readOnly
                    className="mt-1 block w-full px-4 py-3 border border-gray-200 bg-gray-100 rounded-xl text-gray-500 cursor-not-allowed"
                  />
                </div>
                <div className="md:col-span-2">
                  <label className="block text-gray-700 text-sm font-medium">Dirección sucursal</label>
                  <input type="text" name="direccion" value={sucursal.direccion} onChange={handleSucursalChange} className="mt-1 block w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-yellow-200 focus:border-yellow-500 bg-gray-50" />
                </div>
              </div>
              <div className="flex flex-col gap-3 mt-6">
                <button onClick={handleSucursalNext} className="w-full bg-yellow-500 text-white py-3 rounded-xl font-semibold shadow-md hover:bg-yellow-600 transition-all duration-200">Siguiente: Configurar Facturación</button>
                <button
                  onClick={(e) => { e.preventDefault(); setStep(2); }}
                  className="w-full py-3 rounded-xl font-medium text-gray-500 hover:text-gray-700 transition-colors"
                >
                  Volver al Paso Anterior
                </button>
              </div>
            </div>
          )}

          {/* Paso 4: Selección de tipos de factura (DTEs) */}
          {step === 4 && (
            <div className="bg-indigo-50 rounded-2xl p-6 shadow-inner border border-indigo-100 animate-fade-in">
              <h3 className="text-lg font-semibold text-indigo-700 mb-2">Configuración de Facturación</h3>
              <p className="text-sm text-gray-600 mb-6">Selecciona los tipos de documentos electrónicos que emitirá tu negocio (puedes elegir varios).</p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {tiposDocumentoAvailable.map((dte) => (
                  <div
                    key={dte.id}
                    onClick={() => toggleTypeFactSelection(dte.id)}
                    className={`relative p-4 rounded-2xl border-2 transition-all cursor-pointer flex items-center gap-4 ${idTypeFactsSelected.includes(dte.id)
                      ? "border-indigo-500 bg-white shadow-md ring-2 ring-indigo-200"
                      : "border-gray-200 bg-gray-50 opacity-70 hover:opacity-100 hover:border-indigo-300"
                      }`}
                  >
                    <div className="flex-grow">
                      <p className="text-[10px] font-bold text-indigo-500 uppercase tracking-widest">{dte.codigo}</p>
                      <h4 className="text-sm font-semibold text-gray-800">{dte.name}</h4>
                    </div>

                    <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center shrink-0 ${idTypeFactsSelected.includes(dte.id)
                      ? "border-indigo-500 bg-indigo-500"
                      : "border-gray-300"
                      }`}>
                      {idTypeFactsSelected.includes(dte.id) && (
                        <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                        </svg>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-10 flex flex-col gap-3">
                <button
                  onClick={handleShowSummary}
                  disabled={isSubmitting || success !== ""}
                  className={`w-full text-white py-4 rounded-xl font-bold shadow-lg transition-all duration-200 flex items-center justify-center gap-2 transform active:scale-[0.98] ${isSubmitting ? "bg-indigo-400 cursor-not-allowed" : "bg-indigo-600 hover:bg-indigo-700"
                    }`}
                >
                  {isSubmitting ? (
                    <span className="inline-block w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                  ) : (
                    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  )}
                  {isSubmitting ? "Procesando Registro..." : "Revisar y Finalizar Registro"}
                </button>
                <button
                  onClick={() => setStep(3)}
                  disabled={isSubmitting || success !== ""}
                  className="w-full py-3 rounded-xl font-medium text-gray-500 hover:text-gray-700 transition-colors"
                >
                  Regresar a Sucursal
                </button>
              </div>
            </div>
          )}
        </form>
      </div>

      {/* Modal de Resumen */}
      {showSummaryModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
          <div className="bg-white rounded-3xl shadow-2xl w-full max-w-lg overflow-hidden animate-zoom-in">
            <div className="p-6 bg-indigo-600 text-white text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
              </div>
              <h3 className="text-xl font-bold">Resumen del Registro</h3>
              <p className="text-indigo-100 text-sm mt-1">Por favor confirma que los datos son correctos</p>
            </div>

            <div className="p-6 space-y-4 max-h-[60vh] overflow-y-auto custom-scrollbar">
              <div className="border-b border-slate-100 pb-3">
                <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">Negocio</p>
                <p className="text-sm font-semibold text-slate-800">{negocio.company}</p>
                <p className="text-xs text-slate-500">NIT: {negocio.nit}</p>
              </div>
              <div className="border-b border-slate-100 pb-3">
                <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">Usuario</p>
                <p className="text-sm font-semibold text-slate-800">{usuario.nombre} {usuario.apellido}</p>
                <p className="text-xs text-slate-500">{usuario.correo}</p>
              </div>
              <div className="border-b border-slate-100 pb-3">
                <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">Sucursal</p>
                <p className="text-sm font-semibold text-slate-800">{sucursal.nombre}</p>
                <p className="text-xs text-slate-500">{sucursal.direccion}</p>
              </div>
              <div className="pb-3">
                <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">Documentos a Emitir</p>
                <div className="flex flex-wrap gap-1 mt-1">
                  {idTypeFactsSelected.map(id => {
                    const doc = tiposDocumentoAvailable.find(d => d.id === id);
                    return (
                      <span key={id} className="px-2 py-0.5 bg-indigo-50 text-indigo-600 rounded-lg text-[10px] font-bold border border-indigo-100">
                        {doc?.name}
                      </span>
                    );
                  })}
                </div>
              </div>
            </div>

            <div className="p-6 bg-slate-50 border-t border-slate-100 flex flex-col gap-2">
              {error && <div className="p-3 bg-red-100 text-red-700 rounded-xl text-sm text-center">{error}</div>}
              {success && <div className="p-3 bg-green-100 text-green-700 rounded-xl text-sm text-center">{success}</div>}
              <button
                onClick={handleFinalSubmit}
                disabled={isSubmitting || success !== ""}
                className={`w-full text-white py-3 rounded-xl font-bold transition-all shadow-md active:scale-[0.98] ${isSubmitting || success !== "" ? "bg-indigo-400 cursor-not-allowed" : "bg-indigo-600 hover:bg-indigo-700"
                  }`}
              >
                {isSubmitting ? "Procesando..." : "Confirmar y Crear Cuenta"}
              </button>
              <button
                onClick={() => { setError(""); setShowSummaryModal(false); }}
                disabled={isSubmitting || success !== ""}
                className="w-full py-3 text-slate-500 font-medium hover:text-slate-700 transition-colors disabled:opacity-50"
              >
                Cancelar y Revisar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Error */}
      {showErrorModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
          <div className="bg-white rounded-3xl shadow-2xl w-full max-w-sm overflow-hidden animate-zoom-in text-center p-8">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">Error inesperado</h3>
            <p className="text-gray-500 mb-6">{error}</p>
            <button
              onClick={() => setShowErrorModal(false)}
              className="w-full bg-red-500 text-white py-3 rounded-xl font-bold hover:bg-red-600 transition-all shadow-md active:scale-[0.98]"
            >
              Aceptar
            </button>
          </div>
        </div>
      )}

      {/* Modal OTP */}
      {showOTPModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
          <div className="bg-white rounded-3xl shadow-2xl w-full max-w-sm overflow-hidden animate-zoom-in text-center p-8">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">Validación de Correo</h3>
            <p className="text-gray-500 text-sm mb-6">Hemos enviado un código a <b>{usuario.correo}</b> para verificar tu identidad y que los datos sean correctos.</p>
            <br /><p className="text-gray-500 text-sm mb-6 font-bold text-red-500">Si no recibes el código, revisa la carpeta de spam.</p>

            {error && <div className="p-2 mb-4 bg-red-100 text-red-700 rounded-lg text-sm">{error}</div>}

            <input
              type="text"
              placeholder="Ingresa el código"
              value={otpCode}
              onChange={(e) => setOtpCode(e.target.value)}
              className="w-full text-center tracking-widest text-2xl px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-200 focus:border-blue-500 bg-gray-50 mb-6"
              maxLength={8}
            />
            <button
              onClick={handleVerifyAndRegister}
              disabled={isSubmitting}
              className={`w-full text-white py-3 rounded-xl font-bold transition-all shadow-md active:scale-[0.98] ${isSubmitting ? "bg-blue-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"
                }`}
            >
              {isSubmitting ? "Validando..." : "Validar y Crear Cuenta"}
            </button>
            <button
              onClick={() => { setShowOTPModal(false); setShowSummaryModal(true); setIsSubmitting(false); setError(""); }}
              disabled={isSubmitting}
              className="w-full mt-2 py-3 text-slate-500 font-medium hover:text-slate-700 transition-colors disabled:opacity-50"
            >
              Cancelar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Registro;
